import React from "react";
import getConfig from "../environment";
export function getSubdomain() {
  const baseHostname = getConfig()?.baseHostname;
  const hostname = window.location.hostname;
  return hostname.substring(0, hostname.indexOf(baseHostname)-1).toLowerCase();
}
